import { render, staticRenderFns } from "./checkHeader.vue?vue&type=template&id=b4e21e86&scoped=true&"
import script from "./checkHeader.vue?vue&type=script&lang=js&"
export * from "./checkHeader.vue?vue&type=script&lang=js&"
import style0 from "./checkHeader.vue?vue&type=style&index=0&id=b4e21e86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e21e86",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4e21e86')) {
      api.createRecord('b4e21e86', component.options)
    } else {
      api.reload('b4e21e86', component.options)
    }
    module.hot.accept("./checkHeader.vue?vue&type=template&id=b4e21e86&scoped=true&", function () {
      api.rerender('b4e21e86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/check/components/checkHeader.vue"
export default component.exports